import {useSearchParams} from "react-router-dom";

/**
 * @typedef ActiveTabHookParams
 * @property {function} onTabSelect setter for the active page. Hook this up to the TabContainer onSelect
 * @property {string} activeTab The active tab
 */

/**
 * Tab persistence hook to allow pages with multiple tabs to persist the selected tab
 * between refreshes and page navigation.
 *
 * Needs to be connected to the onSelect callback of TabContainer so that it knows the
 * last clicked tab, and also requires a default tab value to be passed as a value to the
 * hook
 *
 * E.g.
 *
 *   const { onTabSelect, activeTab } = useActiveTab( defaultActiveKey ) ;
 *
 * @params {String} defaultTabId  value of the default tab if none are currently on the URL
 *
 * @return ActiveTabHookParams
 *
 * */
const useUrlParamPersist = ( paramName, defaultValue ) =>
{
    const [currentQueryParameters, setSearchParams] = useSearchParams();

    const default_active_tab = currentQueryParameters.get(paramName) ;

    const setValue = (e) =>
    {
        currentQueryParameters.set ( paramName, e ) ;

        setSearchParams(currentQueryParameters, { replace: true });
    }

    const value =  default_active_tab === undefined || default_active_tab === null ? defaultValue : default_active_tab ;

    return { setValue, value }
}

export default useUrlParamPersist ;